import { render } from "./DuplicateGeneticTestDialog.vue?vue&type=template&id=76956250&scoped=true"
import script from "./DuplicateGeneticTestDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateGeneticTestDialog.vue?vue&type=script&lang=js"

import "./DuplicateGeneticTestDialog.vue?vue&type=style&index=0&id=76956250&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76956250"]])

export default __exports__